import { render } from "./ITSupport.vue?vue&type=template&id=42df4b90"
import script from "./ITSupport.vue?vue&type=script&lang=js"
export * from "./ITSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__